import React, { useState } from 'react'
import { useAuth } from '../../Context/ContextProvider'
import { Link } from 'react-router-dom'
function PopularCategory() {
    const [activeTab, setActiveTab] = useState("jobs")
    const {categoriesList, base_url} = useAuth()
    const handleTab = (tab) => {
        setActiveTab(tab)
    }
    return (
        <div className='popular_category_section'>
            <div className='container'>
                <h4 className='home_page_section_title'>Popular Categories</h4>
                <p className='home_page_section_description'>
                    {activeTab==="jobs" ? "Browse the most popular categories of jobs." : "Browse the most popular categories of scholarships."}
                </p>
                <div className='d-flex justify-content-center gap-2'>
                    <button className={`${activeTab === "jobs" ? "active" : ""}`} onClick={() => handleTab("jobs")}>Jobs</button>
                    <button className={`${activeTab === "scholarships" ? "active" : ""}`} onClick={() => handleTab("scholarships")}>Scholarships</button>
                </div>
                <div className='row m-0 mt-3'>
                    {categoriesList?.map((item) => (
                        <div className='col-lg-3 col-md-6 col-12'>
                            <Link to={`/${activeTab === "jobs" ? "find-new-job" : "find-new-scholarship"}?job_category_id=${item?._id}`}>
                            <div className='popular_category_item'>
                                <div className='img_category_container'>
                                <img className='img_category' src={`${base_url}${item?.image}`} alt='...' />
                                </div>
                                <div className='popular_category_item_content'>
                                <h5>{item?.name}</h5>
                                <p>{activeTab === "jobs" ? "Jobs: " + item?.jobCount : "Scholarships: " + item?.scholarshipCount}</p>
                                </div>
                            </div>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default PopularCategory